<template>
  <div>
    SettingsIndex
  </div>
</template>

<script>
export default {
  name: "SettingsIndex",
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      import_to_file:
        "import SettingsIndex from '@~/Documents/NutriBit/frontend/src/pages/Settings/SettingsIndex';"
    };
  },
  created() {}
};
</script>

<style></style>
